import React, { type ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { TrendingsReducer } from "../../../reducers/trendings.reducer";

const TrendingContext = createContext({
	state: TrendingsReducer.getInitialState(),
	actions: TrendingsReducer.actions,
});

export const useTrendingContext = () => useContext(TrendingContext);

export const TrendingProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: TrendingsReducer.getInitialState(),
		reducers: TrendingsReducer.caseReducers,
	});

	return (
		<TrendingContext.Provider value={{ state, actions }}>
			{children}
		</TrendingContext.Provider>
	);
};
